import { RcTrans } from '@/components/atoms/RcTrans'
import { EllipsisBox } from '@/components/molecules/text/EllipsisBox'
import { RcAvatar } from '@/components/molecules/text/RcAvatar'
import { useChatRoomDocument } from '@/entity/chat/useChatRoomDocument'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { ChatRoomProps } from './ChatRoom'

export const ChatRoomHeader = (props: ChatRoomProps) => {
  const { action, focused, chatId, onToggle } = props
  const { room } = useChatRoomDocument({
    idOrKey: chatId
  })

  return (
    <Paper
      elevation={3}
      sx={theme => ({
        py: focused ? 2 : 2,
        px: 2,
        borderRadius: 0
      })}
    >
      <Stack
        direction='row'
        justifyContent={'space-between'}
        spacing={3}
        alignItems='center'
        width='100%'
        onClick={onToggle}
        sx={{
          cursor: onToggle ? 'pointer' : 'default'
        }}
      >
        <Stack direction='row' spacing={3} alignItems='center'>
          {focused ? (
            <RcAvatar
              src={room?.image}
              sx={{ width: 28, height: 28 }}
              variant='rounded'
            >
              {room?.name?.charAt(0)?.toLocaleUpperCase()}
            </RcAvatar>
          ) : null}

          <EllipsisBox lineClamp={2} breakAll={false}>
            <Tooltip title={room?.name}>
              <Typography
                variant={focused ? 'body0' : 'body2'}
                flexGrow={1}
                color='text.primary'
              >
                {room?.name || <RcTrans i18nKey='shared.loading' />}
              </Typography>
            </Tooltip>
          </EllipsisBox>
        </Stack>

        <Stack direction='row' spacing={1} alignItems='center'>
          {action}
        </Stack>
      </Stack>
    </Paper>
  )
}
